#import "@/apollo/fragments/MediaItem.gql"

query MediaItem($mediaItemId: ID!) {
    mediaItem(mediaItemId: $mediaItemId) {
        ...MediaItem
    }
}
